<template>
  <b-modal id="modal-grades" hide-footer scrollable>
    <template #modal-header>
      <h4>
        {{ data.id === null ? $t("grades.new") : $t("grades.edit") }}
      </h4>
    </template>
    <ValidationObserver v-slot="{ handleSubmit }">
      <form @submit.prevent="handleSubmit(onSubmit)">
        <div class="new-user-info">
          <b-row class="justify-content-md-center">
            <b-form-group
              class="col-md-12"
              :label="$t('grades.name')"
              label-for="name"
            >
              <ValidationProvider
                :name="$t('grades.name')"
                rules="required"
                v-slot="{ errors }"
              >
                <b-form-input
                  v-model="data.name"
                  type="text"
                  :placeholder="$t('grades.name')"
                  :class="errors.length > 0 ? ' is-invalid' : ''"
                >
                </b-form-input>
                <div class="invalid-feedback">
                  <span>{{ errors[0] }}</span>
                </div>
              </ValidationProvider>
            </b-form-group>
            <b-form-group
              class="col-md-12"
              :label="$t('grades.initials')"
              label-for="acronym"
            >
              <ValidationProvider
                :name="$t('grades.initials')"
                rules="required"
                v-slot="{ errors }"
              >
                <b-form-input
                  v-model="data.initials"
                  type="text"
                  :placeholder="$t('grades.initials')"
                  :class="errors.length > 0 ? ' is-invalid' : ''"
                >
                </b-form-input>
                <div class="invalid-feedback">
                  <span>{{ errors[0] }}</span>
                </div>
              </ValidationProvider>
            </b-form-group>
            <b-form-group
              class="col-md-12"
              :label="$t('grades.type-education')"
              label-for="education"
            >
              <ValidationProvider
                :name="$t('grades.type-education')"
                rules="required"
                v-slot="{ errors }"
              >
                <v-select
                  v-model="data.education_type"
                  :placeholder="$t('grades.type-education')"
                  :options="getEducation"
                  label="name"
                  :class="errors.length > 0 ? ' is-invalid' : ''"
                >
                  <template #no-options="{}">
                    {{ $t("app.not-found") }}...
                  </template>
                </v-select>
                <div v-if="errors[0]">
                  <small class="text-danger">{{ errors[0] }}</small>
                </div>
              </ValidationProvider>
            </b-form-group>
          </b-row>
          <hr />
          <b-button
            :disabled="gradesLoading"
            variant="success"
            class="float-right"
            type="submit"
          >
            <span v-if="gradesLoading">
              <b-spinner small type="grow"></b-spinner>
              {{ $t("app.loading") }}...
            </span>
            <span v-else>
              {{ $t("app.save") }}
            </span>
          </b-button>
          <b-button
            class="float-right mr-1"
            @click="$bvModal.hide('modal-grades')"
            variant="outline-danger"
            type="reset"
          >
            {{ $t("app.cancel") }}
          </b-button>
        </div>
      </form>
    </ValidationObserver>
  </b-modal>
</template>
<script>
import { core } from "@/config/pluginInit";
import { mapActions, mapGetters } from "vuex";
export default {
  name: "modalForm",
  mounted() {
    core.index();
    this.fetchEducation();
  },
  data() {
    return {
      data: {
        id: null,
        name: null,
        initials: null,
        education_type: null,
      },
    };
  },
  methods: {
    ...mapActions({
      saveForm: "storeGrades",
      fetchEducation: "fetchEducation",
    }),
    async show(item) {
      this.reserForm();
      if (item) {
        this.data = {
          id: item.id,
          name: item.name,
          initials: item.initials,
          education_type: item.typeEducation,
        };
      }
      this.$bvModal.show("modal-grades");
    },
    async onSubmit() {
      let payload = {
        id: this.data.id,
        name: this.data.name,
        initials: this.data.initials,
        type_education_id: this.data.education_type.id,
      };
      const resp = await this.saveForm(payload);
      this.$bvModal.hide("modal-grades");
      this.$emit("refresh");
      if (resp.status === 201 || resp.status === 200) {
        core.showSnackbar(
          "success",
          !this.data.id
            ? this.$t("app.success-create")
            : this.$t("app.success-edit")
        );
      }
      this.reserForm();
    },
    reserForm() {
      this.data = {
        id: null,
        name: null,
        initials: null,
      };
    },
  },
  computed: {
    ...mapGetters({
      gradesLoading: "gradesLoading",
      getEducation: "getEducation",
    }),
  },
};
</script>
